interface Props {
  variant?: 'default' | 'white';
  width?: number;
  className?: string;
}

const PATH =
  'M90.3939 8.3154C85.6573 7.08388 84.7552 6.89916 84.7552 5.42805C84.7552 3.8249 86.2915 3.26133 87.6148 3.26133C89.5967 3.26133 91.2148 3.8541 91.344 6.15001H95.3645C95.3645 1.73939 91.7402 0 87.7984 0C85.362 0 82.8065 0.984539 81.5428 2.94925L81.5382 0.454519H77.3827V12.322C77.3827 15.16 76.8126 16.4687 73.8461 16.4687C70.4876 16.4687 70.3364 14.4109 70.3364 12.322V0.454519H66.1834L66.2011 4.8581C65.0055 1.73452 62.0262 0 58.5636 0C53.9649 0 50.8309 2.73399 49.7143 6.66007V0.454519H45.5593V6.65822C44.5014 2.4996 41.3229 0.454519 37.3494 0.454519H13.7413L9.94076 13.5799H9.88465L5.84851 0.454519H0V19.5426H3.89021V7.05754H3.94034L8.01018 19.5426H11.5748L15.5417 7.22683V19.5426H37.3494C41.9674 19.5426 44.6598 16.9068 45.5593 13.0094V19.5426H49.7143V13.3822C50.8249 17.2504 53.948 20 58.5636 20C62.3649 20 65.2338 17.9443 66.3725 14.5756C67.0606 18.2351 69.5711 20 73.8461 20C77.3413 20 79.6587 18.7502 80.771 16.2984C82.0445 18.8715 85.0097 20 88.1429 20C93.2759 20 96 17.3791 96 13.8778C96 9.54473 91.7671 8.6617 90.3939 8.3154ZM29.4839 16.0164H19.6928V11.3373H28.3781V8.07379H19.6928V3.98195H29.4839V16.0164ZM37.0582 16.0164H33.6399V3.98195H36.3189C40.4434 3.98195 41.7672 6.44564 41.7672 10.2944C41.7672 14.5213 39.4655 16.0164 37.0582 16.0164ZM66.1834 13.3763H62.62C62.0287 15.1964 60.6488 16.4687 58.5636 16.4687C54.8325 16.4687 53.4323 13.2656 53.4323 10.0793C53.4323 6.7354 54.8325 3.53095 58.5636 3.53095C60.5434 3.53095 62.28 4.86531 62.6527 6.65067H66.1834V13.3763ZM88.3034 16.7372C86.0843 16.7372 84.1235 15.7622 84.1235 13.222H81.507C81.5274 12.9193 81.5382 12.6472 81.5382 12.322L81.5523 8.60952C82.5998 10.0526 84.4982 10.7061 86.3737 11.2016C89.1486 11.9517 91.9798 12.298 91.9798 14.3579C91.9798 16.3071 89.7572 16.7372 88.3034 16.7372Z';

export function MedicusLogo({ variant = 'default', width = 96, className }: Props) {
  const fill = variant === 'white' ? '#FFFFFF' : '#002564';
  // Logo original es 96x20 pero el path llega justo hasta y=20, lo que en
  // algunos browsers + pixel rounding hace que se vea cortado por abajo.
  // Damos 1px de respiro debajo (viewBox 21, height proporcional) y forzamos
  // display:block para evitar el descender baseline del inline SVG.
  const height = (width * 21) / 96;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Medicus"
      style={{ display: 'block', overflow: 'visible' }}
    >
      <path d={PATH} fill={fill} />
    </svg>
  );
}
